<script>
    import Card from './Card.svelte';
    import { flip } from 'svelte/animate';
    import { onMount, afterUpdate } from 'svelte';

    export let cards;
    export let subCards = [];
    export let cardWidth = 300; // in pixels
    
    export let displayControls = true;
    export let optionExpandDown = false;
    export let transitionSpeed = 500;

    let parentElement;
    let cardElements = [];
    let activeElementIndex = 0; // this doesn't currently detect whether more than one card (element) is already visible
    let activeCardGroup;

    // onMount(() => {
    //     cardElements = [...parentElement.querySelectorAll('.card-wrapper')]
    // })

    afterUpdate(() => {
        cardElements = [...parentElement.querySelectorAll('.card-wrapper')]
    })

    const scrollLeft = function(){
        activeElementIndex = Math.max(0, activeElementIndex - 1);
        const el = cardElements[activeElementIndex]
        el.scrollIntoView({block: "nearest", inline: "center", behavior: "smooth"});
    }

    const scrollRight = function(){
        activeElementIndex = Math.min(cardElements.length - 1, activeElementIndex + 1); 
        const el = cardElements[activeElementIndex]
        el.scrollIntoView({block: "nearest", inline: "center", behavior: "smooth"});
    }

    function handleFlipped(e){
        if(optionExpandDown){
            // once a card is flipped, unflip all other cards
            let newlyFlipped = e.detail.id;
            cards.forEach(card => {
                if (card.id != newlyFlipped){
                    card.flipped = false;
                } 
            })
        }
    }

</script>

<div class="container">
    <div id="carousel" style="--button-pos: {cardWidth/3*2}px">
        <div id="cards" bind:this={parentElement}>
            {#each cards as card, i (card.id)}
            <div class="card-wrapper" id={card.id} animate:flip="{{ duration: transitionSpeed }}" visible={card.visible}>
                <Card id={card.id} iconName={card.icon_name} colours={card.colours} cardWidth={cardWidth} text={card.text_body} on:flipped={handleFlipped} bind:flipped={card.flipped}> 
                    <span slot="front">{card.title_front}</span>
                    <span slot="back">{card.title_back}</span>
                </Card>
                {#if card.flipped && optionExpandDown}
                    {#each subCards[i].filter(d => d.category == card.category) as subCard}
                    <Card id={subCard.id} iconName={subCard.icon_name} colours={subCard.colours} cardWidth={cardWidth} text={subCard.text_body}> 
                        <span slot="front">{subCard.title_front}</span>
                        <span slot="back">{subCard.title_back}</span>
                    </Card>
                    {/each}
                {/if}
            </div>
            {:else}
                <p>Loading...</p>
            {/each}
        </div>
        {#if displayControls}  
        <!-- {#if activeElementIndex > 0} -->
            <button on:click={scrollLeft} class="left"><slot name="left-control">Left</slot></button>
        <!-- {/if} -->
        <!-- {#if activeElementIndex < (cards.length - 1)} -->
            <button on:click={scrollRight} class="right"><slot name="right-control">Right</slot></button>
        <!-- {/if} -->
        {/if}
    </div>
</div>


<style>
    .container {
        width: 100%;
    }

    #carousel {
        /* for button positioning */
        position: relative; 
    }

    button {
        position: absolute;
        top: var(--button-pos);
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
    }
    
    button:focus {
        outline: auto;
    }
    
    button.left {
        left: 5%;
    }
    
    button.right {
        right: 5%;
    }
    
    #cards {
        display:flex;
        align-items: flex-start;
        width: 80%;
        margin: 0 auto;
        overflow-x: scroll;
        scroll-snap-type: x mandatory;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }

    #cards .card-wrapper {
        scroll-snap-align: center;
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    #cards::-webkit-scrollbar {
        display: none;
    }


    @media only screen and (max-width: 600px) {
        #cards {
            width: 95%;
        }
        button.left {
            left: 2%;
        }
        
        button.right {
            right: 2%;
        }
	}
    @media only screen and (max-width: 400px) {
        #cards {
            width: 100%;
        }
    }


</style>